import React from "react";
import { Icon } from "./Icon.jsx";

/* Text-style action button with optional icon — replaces legacy uiComponents LinkButton. */
export function LinkButton({
  buttonText,
  icon,
  iconPosition = "left",
  removePadding = false,
  onClick,
  disabled,
  style,
  type = "button",
  ...rest
}) {
  const showIcon = icon !== null && icon !== undefined;
  const iconNode = showIcon ? icon || <Icon name="plus" size={24} /> : null;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: removePadding ? 0 : 5,
        padding: removePadding ? 0 : undefined,
        margin: 0,
        border: "none",
        background: "transparent",
        cursor: disabled ? "not-allowed" : "pointer",
        color: "var(--primary)",
        fontFamily: "var(--font-sans)",
        fontWeight: 600,
        fontSize: 16,
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
      {...rest}
    >
      {iconPosition === "left" && iconNode}
      <span style={{ margin: 0 }}>{buttonText}</span>
      {iconPosition === "right" && iconNode}
    </button>
  );
}

export default LinkButton;
